<template>
  <section>
    <v-container fluid class="text-center mt-10">
      <History />
      <div class="mb-10">
        <span
          :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
          class="font-weight-black black--text custom-font"
        >
          CORE
        </span>
        <span
          :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
          class="font-weight-black red--text custom-font"
        >
          VALUES
        </span>
      </div>
      <v-parallax
        :height="$vuetify.breakpoint.smAndDown ? 1000 : 800"
        src="@/assets/ems_images/background2.webp"
      >
        <CoreValues class="my-10" />
      </v-parallax>
      <div class="mt-10">
        <span
          :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
          class="font-weight-black black--text"
        >
          OUR
        </span>
        <span
          :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
          class="font-weight-black red--text"
        >
          PARTNERS
        </span>
      </div>
      <v-slide-group class="pa-4" show-arrows>
        <!-- Each v-slide-group-item represents one image inside an avatar -->
        <v-slide-group-item v-for="(image, index) in images" :key="index">
          <v-avatar size="150" class="ma-10">
            <v-img :src="image.src" height="100%" width="100%" contain></v-img>
          </v-avatar>
        </v-slide-group-item>
      </v-slide-group>

      <div class="mb-10">
        <span
          :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
          class="font-weight-black black--text"
        >
          OUR
        </span>
        <span
          :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
          class="font-weight-black red--text"
        >
          CERTIFICATIONS
        </span>
      </div>
      <v-parallax
        :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
        src="@/assets/ems_images/toronto1.webp"
      >
        <v-img
          src="@/assets/ems_images/certifications.png"
          style="max-width: 100%; max-height: 300px"
          contain
        ></v-img>
      </v-parallax>
      <div class="ma-10" style="background-color: #fafafa">
        <v-img
          src="@/assets/ems_images/environment.png"
          style="max-width: 100%; max-height: 300px"
          contain
        ></v-img>
      </div>
    </v-container>
  </section>
</template>





<script>
import History from "./History";
import CoreValues from "./CoreValues.vue";

export default {
  name: "AboutDesktopSection",
  components: {
    History,
    CoreValues,
  },
  data() {
    return {
      model: null,
      images: [
        { src: require("@/assets/ems_images/del.png") },
        { src: require("@/assets/ems_images/citysights.png") },
        { src: require("@/assets/ems_images/crossbridge.png") },
        { src: require("@/assets/ems_images/first_service.png") },
        { src: require("@/assets/ems_images/icc.png") },
        { src: require("@/assets/ems_images/icon_property.jpg") },
        { src: require("@/assets/ems_images/medallion.png") },
        { src: require("@/assets/ems_images/nadian.png") },
        { src: require("@/assets/ems_images/park_properties.png") },
        { src: require("@/assets/ems_images/princess.png") },
        { src: require("@/assets/ems_images/stronghold.png") },
        { src: require("@/assets/ems_images/westdalepng.png") },
        // ... any additional images
      ],
    };
  },
};
</script>


